export default function TrackpadDeactiveIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="52"
      height="51"
      viewBox="0 0 52 51"
      fill="none"
    >
      <g clip-path="url(#clip0_808_6549)">
        <path
          d="M46.1875 44.625H16.9475C16.6657 44.625 16.3955 44.5131 16.1962 44.3138C15.9969 44.1145 15.885 43.8443 15.885 43.5625C15.885 43.2807 15.9969 43.0105 16.1962 42.8112C16.3955 42.6119 16.6657 42.5 16.9475 42.5H46.1875C47.9449 42.5 49.375 41.0699 49.375 39.3125V32.9375C49.375 32.6557 49.4869 32.3855 49.6862 32.1862C49.8855 31.9869 50.1557 31.875 50.4375 31.875C50.7193 31.875 50.9895 31.9869 51.1888 32.1862C51.3881 32.3855 51.5 32.6557 51.5 32.9375V39.3125C51.5 42.2408 49.1179 44.625 46.1875 44.625ZM7.9375 44.625H5.8125C4.40406 44.6233 3.05378 44.0631 2.05786 43.0671C1.06194 42.0712 0.501687 40.7209 0.5 39.3125L0.5 32.9375C0.5 32.6557 0.611942 32.3855 0.811199 32.1862C1.01046 31.9869 1.28071 31.875 1.5625 31.875C1.84429 31.875 2.11454 31.9869 2.3138 32.1862C2.51306 32.3855 2.625 32.6557 2.625 32.9375V39.3125C2.625 41.0699 4.05512 42.5 5.8125 42.5H7.9375C8.21929 42.5 8.48954 42.6119 8.6888 42.8112C8.88806 43.0105 9 43.2807 9 43.5625C9 43.8443 8.88806 44.1145 8.6888 44.3138C8.48954 44.5131 8.21929 44.625 7.9375 44.625Z"
          fill="#F05542"
        />
        <path
          d="M51.0112 9.49875L26.51 34H51.5V11.6875C51.5 10.9012 51.33 10.1787 51.0112 9.49875ZM5.8125 6.375C4.40354 6.375 3.05228 6.93471 2.056 7.931C1.05971 8.92728 0.5 10.2785 0.5 11.6875L0.5 34H17.5L45.125 6.375H5.8125Z"
          fill="#F05542"
        />
        <path
          d="M25.9998 44.625C25.718 44.625 25.4477 44.5131 25.2485 44.3138C25.0492 44.1146 24.9373 43.8443 24.9373 43.5625V34.51C24.9373 34.2282 25.0492 33.958 25.2485 33.7587C25.4477 33.5595 25.718 33.4475 25.9998 33.4475C26.2816 33.4475 26.5518 33.5595 26.7511 33.7587C26.9503 33.958 27.0623 34.2282 27.0623 34.51V43.5625C27.0623 43.8443 26.9503 44.1146 26.7511 44.3138C26.5518 44.5131 26.2816 44.625 25.9998 44.625ZM1.56228 51C1.35229 51 1.14703 50.9377 0.972412 50.8211C0.797792 50.7045 0.661641 50.5388 0.581154 50.3448C0.500666 50.1509 0.47945 49.9374 0.520185 49.7314C0.560919 49.5254 0.661778 49.3361 0.810025 49.1874L49.685 0.312416C49.8854 0.118874 50.1538 0.0117795 50.4324 0.0142003C50.711 0.0166211 50.9775 0.128363 51.1745 0.325359C51.3715 0.522355 51.4832 0.788844 51.4856 1.06743C51.488 1.34601 51.3809 1.6144 51.1874 1.81479L2.3124 50.6898C2.21394 50.7883 2.09699 50.8665 1.96827 50.9197C1.83954 50.9729 1.70158 51.0002 1.56228 51Z"
          fill="#F05542"
        />
      </g>
      <defs>
        <clipPath id="clip0_808_6549">
          <rect
            width="51"
            height="51"
            fill="white"
            transform="translate(0.5)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}
